<template>
  <div>
    <vx-card class="mt-base mb-5">
      <heading size="h2" style-size="h4" class="mb-5">{{ activityTitle }}</heading>
      <p class="mb-5">
        Self-talk is one important psychological process that greatly affects our mindset. Self-talk
        refers to that little voice in our head. It’s what we tell ourselves about situations we
        find ourselves in.
      </p>
      <p class="mb-5">
        Sometimes our self-talk is positive, like when it tells us encouraging things like “I know I
        can do this!” or “I will pass this test.”
      </p>
      <p class="mb-5">
        At other times, our self talk can be negative, like when we say things to ourselves like
        “This is too difficult for me!” or “There’s no way I can pass this test.”
      </p>
      <p class="mb-5">
        <strong
          >Think about your own mindset and your self-talk. Is your self mostly positive or
          negative?</strong
        >
      </p>
      <p class="mb-5">
        Most of us have a mix of positive and negative self-talk. The trick to changing negative
        self-talk into positive self-talk is to realise when we are doing it. Once we’re aware of
        it, we can work to change the self-talk from negative into positive.
      </p>
      <p class="mb-5">Watch this short video to learn 2 strategies on how to do this.</p>

      <custom-video
        aria-label="Watch becoming becoming registered video"
        elem-id="video-btn-0"
        :video-image="videoTrigger1"
        :video-url="videos[1]"
      />
      <h4 class="mb-5">Your Task:</h4>
      <p class="mb-5">
        Your challenge over the next 7 days, is to recognise at least one occasion each day when you
        are engaged in negative self-talk and use the distract or combat strategy from the video
        above to end the negative thinking.
      </p>
      <p class="mb-5">
        Download the “Creating Positive Self-Talk” sheet below and complete it over the 7-day
        period. Try to complete as much of it as you can before uploading the completed sheet at the
        end of the week.
      </p>

      <p><strong>Download Creating Positive Self-Talk Sheet</strong></p>
      <p class="mb-5">
        <small
          ><strong>Note:</strong> You must download this sheet to your computer before working on
          it.</small
        >
      </p>
      <a
        :href="'content/psychology/positive_self_talk.pdf' | blob_url"
        target="_blank"
        class="no-underline btn btn-secondary btn-size-medium includedIcon mt-5"
      >
        <download-icon />
        Download Positive Self-Talk Sheet
      </a>
      <vs-divider />

      <p><strong>Upload Positive Self-Talk Sheet:</strong></p>
      <br />
      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_1']"
        :is-editable="isEditable"
        filetype="pdf"
        index="1"
      />

      <p class="my-5">
        As a psychologist, you need to understand this yourself before trying to counsel others.
      </p>
      <div class="focusable-parent">
        <label>
          In the comments field, below give an example of a positive outcome that you experienced
          using one or both of these techniques. If you were unable to do this, just explain why you
          found it difficult.
          <textarea-block
            v-model="data.question1"
            :editable="isEditable"
            class="focus-visible-style"
          />
        </label>
      </div>

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import { DownloadIcon } from 'vue-feather-icons';
import CustomVideo from '@/components/CustomVideo';

export default {
  components: {
    DownloadIcon,
    CustomVideo,
  },
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/psychology/negative_thinking_trigger.jpg'),
      videos: {
        1: 'https://www.youtube.com/embed/_XLY_XXBQWE',
      },
      login_type: localStorage.getItem('login_type'),
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
